import { error, clear } from '../alert/alert.actions';
import { AppDispatch } from '../../../models/redux/dispatch/app.dispatch';
import authFetch from '../../../utils/authFetch';
import { Group, Role, State, Status } from '../../../models/enums/Enums';
import { SET_GROUPS, SET_ROLES, SET_STATES, SET_STATUSES } from '../../../constants/enums.constants';
import {
  SetGroupsAction,
  SetRolesAction,
  SetStatesAction,
  SetStatusesAction,
} from '../../../models/redux/actions/enums.action';
import NETWORK_CONSTANTS from '../../../constants/network.constants';

export function setRoles(roles: Role[]): SetRolesAction {
  return {
    type: SET_ROLES,
    roles,
  };
}

export function setStates(states: State[]): SetStatesAction {
  return {
    type: SET_STATES,
    states,
  };
}

export function setGroups(groups: Group[]): SetGroupsAction {
  return {
    type: SET_GROUPS,
    groups,
  };
}

export function setStatuses(statuses: Status[]): SetStatusesAction {
  return {
    type: SET_STATUSES,
    statuses,
  };
}

const getRolesAPIcall = () => {
  return (dispatch: AppDispatch) => {
    const url = `${NETWORK_CONSTANTS.BASE_URL}${NETWORK_CONSTANTS.API_ROLES}`;
    authFetch(dispatch, url, 'GET')
      .then((json) => {
        dispatch(setRoles(json));
      })
      .catch((err) => {
        dispatch(error(err.message));
        setTimeout(() => {
          dispatch(clear());
        }, 6000);
      });
  };
};

const getStatesAPIcall = () => {
  return (dispatch: AppDispatch) => {
    const url = `${NETWORK_CONSTANTS.BASE_URL}${NETWORK_CONSTANTS.API_STATES}`;
    authFetch(dispatch, url, 'GET')
      .then((json) => {
        dispatch(setStates(json));
      })
      .catch((err) => {
        dispatch(error(err.message));
        setTimeout(() => {
          dispatch(clear());
        }, 6000);
      });
  };
};

const getGroupsAPIcall = () => {
  return (dispatch: AppDispatch) => {
    const url = `${NETWORK_CONSTANTS.BASE_URL}${NETWORK_CONSTANTS.API_GROUPS}`;
    authFetch(dispatch, url, 'GET')
      .then((json) => {
        dispatch(setGroups(json.results));
      })
      .catch((err) => {
        dispatch(error(err.message));
        setTimeout(() => {
          dispatch(clear());
        }, 6000);
      });
  };
};

const getStatusesAPIcall = () => {
  return (dispatch: AppDispatch) => {
    const url = `${NETWORK_CONSTANTS.BASE_URL}${NETWORK_CONSTANTS.API_STATUSES}`;
    authFetch(dispatch, url, 'GET')
      .then((json) => {
        dispatch(setStatuses(json.results));
      })
      .catch((err) => {
        dispatch(error(err.message));
        setTimeout(() => {
          dispatch(clear());
        }, 6000);
      });
  };
};

export { getRolesAPIcall, getStatesAPIcall, getGroupsAPIcall, getStatusesAPIcall };
